export default function NotFound() {
    return (
        <div className="d-flex flex-column mh-100vh align-items-center justify-content-center ">
            <h1 className="display-3" >404 page not found</h1>
            <p className="p-3">OOPS, the page you are looking for doesn't exist.</p>
        </div>
    )
}